module.exports = __webpack_public_path__ + "static/media/gmail.e097ea97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/gmail.svg
// module id = 29
// module chunks = 0